import Repository from "./Repository";

const CREATE_MEMBERSHIP = "create";
const GET_MEMBERSHIP = "get";
const GET_ALL_MEMBERSHIP = "getall";
const UPDATE_MEMBERSHIP = "update";
const DELETE_MEMBERSHIP = "delete";
const MEMBERSHIP_VALIDITY_CHECK = "membershipValidityCheck";
const UNIQUE_MONTH_CHECK = "uniqueMonthCheck";

export default {
  createMembership(payload) {
    return Repository.post(transformRoute(CREATE_MEMBERSHIP), payload);
  },
  getSingleMembership(payload) {
    return Repository.post(transformRoute(GET_MEMBERSHIP), payload);
  },
  getAllMembership(payload) {
    return Repository.post(transformRoute(GET_ALL_MEMBERSHIP), payload);
  },
  updateMembership(payload) {
    return Repository.post(transformRoute(UPDATE_MEMBERSHIP), payload);
  },
  deleteMembership(payload) {
    return Repository.post(transformRoute(DELETE_MEMBERSHIP), payload);
  },
  membershipValidityCheck(payload) {
    return Repository.post(transformRoute(MEMBERSHIP_VALIDITY_CHECK), payload);
  },
  uniqueMonthCheck(payload) {
    return Repository.post(transformRoute(UNIQUE_MONTH_CHECK), payload);
  },
};

const transformRoute = (route) => {
  return `/membership/${route}`;
};
